const baseURL = "https://6o22xu4u61.execute-api.ap-south-1.amazonaws.com/dev/api/grn/"

export const createGRNAPI = baseURL+"createGRN"
export const getAllGRN = baseURL+"viewAllGRNList/"

